import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import PersetujuanKbSvc from "@/services/PersetujuanKb";

@Module({ store, dynamic: true, namespaced: true, name: "persetujuan-kb" })
class PersetujuanKbModule extends VuexModule {
  items: any[] = [];
  currentItem: any = null;
  loading = false;
  metodeMap: Record<number, any> = {};

  @Mutation SET_ITEMS(val: any[]) {
    this.items = val;
  }

  @Mutation SET_CURRENT_ITEM(val: any) {
    this.currentItem = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation SET_METODE_MAP(val: Record<number, any>) {
    this.metodeMap = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);
    try {
      const dt = await PersetujuanKbSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_ITEMS(data || []);
    } catch {
      this.SET_ITEMS([]);
    }
    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await PersetujuanKbSvc.find(id);
      const { data } = dt.data;
      this.SET_CURRENT_ITEM(data);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }
    this.SET_LOADING(false);
  }

  @Action async loadMetodeList() {
    if (Object.keys(this.metodeMap).length > 0) return;
    try {
      const dt = await PersetujuanKbSvc.metodeList();
      this.SET_METODE_MAP(dt.data.data || {});
    } catch {
      this.SET_METODE_MAP({});
    }
  }

  @Action reset() {
    this.SET_ITEMS([]);
    this.SET_CURRENT_ITEM(null);
  }
}

export const storePersetujuanKb = getModule(PersetujuanKbModule);
